import styled, { css } from 'styled-components';

export const CurrentImage = styled.img(
  ({ theme }) => css`
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: ${theme.sz.s3};
    background-color: ${theme.co.primary95};
  `,
);

export const CurrentFallback = styled.div(
  ({ theme }) => css`
    display: grid;
    place-items: center;
    width: 100%;
    aspect-ratio: 1;
    border-radius: ${theme.sz.s3};
    background-color: ${theme.co.primary95};
    color: ${theme.co.primary0};
    font-size: ${theme.sz.s12};
  `,
);
